import { render, staticRenderFns } from "./blocks.vue?vue&type=template&id=7e67489e&"
import script from "./blocks.vue?vue&type=script&lang=ts&"
export * from "./blocks.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports